import { render, staticRenderFns } from "./dataTable.vue?vue&type=template&id=201a4c42&scoped=true&"
import script from "./dataTable.vue?vue&type=script&lang=js&"
export * from "./dataTable.vue?vue&type=script&lang=js&"
import style0 from "./dataTable.vue?vue&type=style&index=0&id=201a4c42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201a4c42",
  null
  
)

export default component.exports